module.exports = __webpack_public_path__ + "img/close-s.a6983bec.svg";